import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PriceAlertV2 } from '../components/PriceAlertV2';
import { HeroV2 } from '../components/HeroV2';
import { TestimonialV2 } from '../components/TestimonialV2';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStackV2 } from '../components/ValueStackV2';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSectionV2 } from '../components/PricingSectionV2';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageV2() {
  const [showContent, setShowContent] = useState(false);
  const handleVideoMilestone = () => {
    setShowContent(true);
  };
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1438">
      <PriceAlertV2 data-id="element-1439" />
      <HeroV2 onVideoMilestone={handleVideoMilestone} showCTA={showContent} data-id="element-1440" />
      <AnimatePresence data-id="element-1441">
        {showContent && <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-1442">
            <TestimonialV2 data-id="element-1443" />
            <ProblemSolution data-id="element-1444" />
            <ValueStackV2 data-id="element-1445" />
            <ModuleBreakdown data-id="element-1446" />
            <Guarantee data-id="element-1447" />
            <PricingSectionV2 data-id="element-1448" />
            <Footer data-id="element-1449" />
          </motion.div>}
      </AnimatePresence>
      {showContent && <RecentPurchaseToast data-id="element-1450" />}
    </div>;
}